// Maps a failed POST /orders/{orderId}/payment-return (C-10) to the record
// dialog's INLINE copy for a TERMINAL failure — one a retry would only repeat,
// so the dialog keeps Record disabled:
// - 409: not_bank_payment, payment_not_captured (still settling, never
//   settled, or already returned) or order_cancelled. Each means the order
//   changed since the page loaded. useOrderApi keeps these out of useApi's
//   toast.
// - 404: the order is gone.
// Everything else returns undefined: useApi already toasted it, and the caller
// shows its own failure copy and allows a retry.
//
// Modeled on returnedPaymentFeeError.ts: for a 409 the server message wins,
// with our copy as the floor.

import { asApiFailure, parseFailureBody } from "@utils/apiFailure";

// Must hold even when the return IS already recorded (a retry after a timeout,
// or the settlement job recording it first), so it never says nothing was.
const REFUSAL_FALLBACK =
    "This payment can't be recorded as returned now. It may already be recorded, so check its payment status on this page.";

const ORDER_NOT_FOUND = "Order not found. The return wasn't recorded.";

export const paymentReturnRefusal = (error: unknown): string | undefined => {
    const failure = asApiFailure(error);

    if (failure?.status === 404) {
        return ORDER_NOT_FOUND;
    }

    if (failure?.status !== 409) {
        return undefined;
    }

    const message = parseFailureBody(failure.detail)?.message.trim();

    return message ? message : REFUSAL_FALLBACK;
};
